import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { bool, func, number, object, objectOf } from 'prop-types';
import Icon from 'yoda-core-components/lib/components/Icon';
import YdtFilter from 'yoda-core-components/lib/assets/svg/YdtFilter.svg';
import classNames from 'classnames/bind';
import { getLocaleString } from 'yoda-site-components/lib/components/Pricing/PricingHelper';
import MessageBox from 'yoda-core-components/lib/components/MessageBox/MessageBox';
import FeatureFlag from 'yoda-core-components/lib/components/FeatureFlag/FeatureFlag';
import GallerySliderConnected from '../GallerySlider/GallerySlider';
import StoreFilterCategoryConnected from '../StoreFilterCategory/StoreFilterCategory';
import FloatingFilterButtonConnected from '../FloatingFilterButton/FloatingFilterButton';
import SortBy from '../SortBy/SortBy';
import * as sliderActions from '../../actions/SliderActions';
import * as styles from './FilterHeader.css';
import selectNoSearchResults from '../../selectors/NoSearchResults';
import { selectLastAction, selectDisablePrevNoResultsMessage } from '../../selectors/fromState';
import { prevNoResultsMessage } from '../../common/constants';
import { selectEnableDesktopViewForTabletLandscapeOrientation } from '../../selectors/FeatureFlag';
import { getURLParameterBykey, goUrl, removeQueryStringParameter, updateUrl } from '../../utils';

const cx = classNames.bind(styles);

/* istanbul ignore next */
export class FilterHeader extends PureComponent {
    static defaultProps = {
        countOfSearchResults: 0,
        countOfSelectedFilters: 0,
        deviceType: {},
        prevResults: {},
        router: {
            location: {
                search: '',
            },
        },
    };

    static propTypes = {
        actions: objectOf(func).isRequired,
        disablePrevNoResultsMessage: bool.isRequired,
        enableDesktopViewForTablet: bool.isRequired,
        countOfSearchResults: number,
        countOfSelectedFilters: number,
        deviceType: object,
        noResults: bool.isRequired,
        prevResults: object,
        router: object,
    };

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        const {
            actions: { showSlider },
            router: { location },
            router: {
                location: { search },
            },
        } = this.props;
        let urlStatus;

        if (location) {
            urlStatus = getURLParameterBykey('filters', search);
        }
        if (urlStatus && urlStatus.indexOf('open') !== -1) {
            showSlider();
            goUrl(removeQueryStringParameter(undefined, 'filters'), true);
        }
    }

    sortChangeCB = (e) => {
        updateUrl(e, null, null, {});
    };

    searchResultCount = () => {
        const { noResults, countOfSearchResults } = this.props;

        const gTitleClasses = [
            'font-open-sans-regular',
            'mt-1',
            'text-gray-600',
            'text-medium',
            'whitespace-no-wrap',
            cx('gTitle'),
        ].join(' ');

        if (!noResults && countOfSearchResults) {
            return (
                <div className={gTitleClasses}>
                    {getLocaleString(countOfSearchResults)}
                    {countOfSearchResults > 1 ? ' Results' : ' Result'}
                </div>
            );
        }
        return null;
    };

    filterBtn = () => {
        const {
            actions: { toggleSlider },
            countOfSelectedFilters,
        } = this.props;
        return (
            <button
                type="button"
                onClick={toggleSlider}
                className="text-small"
                data-automation-id="product-filter-button"
            >
                <span className="mr-1">
                    <Icon
                        automationId="filter-icon"
                        className="icon"
                        height="18"
                        viewBox="0 0 40 40"
                        width="18"
                    >
                        <YdtFilter />
                    </Icon>
                </span>
                Filter
                {countOfSelectedFilters > 0 && <span>{` (${countOfSelectedFilters})`}</span>}
            </button>
        );
    };

    renderPrevNoResultsMessageSection = () => {
        const {
            prevResults: { prevNoResults = false },
            disablePrevNoResultsMessage,
        } = this.props;

        let prevNoResultsMessageSection = null;

        if (prevNoResults && !disablePrevNoResultsMessage) {
            prevNoResultsMessageSection = (
                <div className={cx('gallerySearchInfoMsgBlock')}>
                    <MessageBox
                        automationId="noResultsInfoMsg"
                        hasClose={false}
                        level="section"
                        showMessage
                        title={prevNoResultsMessage}
                        type="information"
                    />
                </div>
            );
        }

        return prevNoResultsMessageSection;
    };

    renderMobile = () => {
        const {
            actions: { toggleSlider },
            deviceType: { isTablet, isMobile, isDesktop, isBot },
            enableDesktopViewForTablet,
        } = this.props;

        const wrapperClasses = cx('mb-2', { 'lg:hidden': enableDesktopViewForTablet && !isBot });

        const secondaryWrapperClasses = [
            'font-open-sans-bold',
            'text-gray-600',
            'text-small',
            cx({
                'flex-col': isMobile,
                block: isTablet,
                flex: !isTablet,
            }),
        ].join(' ');

        const gridViewClasses = [
            'border-gray-200',
            'border-solid',
            'border-t-1 border-b-1',
            'flex-1',
            'mb-1',
            'py-2',
            cx('gridView'),
        ].join(' ');

        const gridItemClasses = ['inline-block', 'text-center', 'w-1/2', cx('gridItem')].join(' ');

        const StoreFilterCategoryClasses = cx({
            'my-1': (isTablet && !enableDesktopViewForTablet) || isDesktop,
            'my-2-updated': isTablet && enableDesktopViewForTablet,
            'my-1-updated': isMobile,
        });

        return (
            <div className={wrapperClasses} data-component-name="FilterHeader">
                {this.renderPrevNoResultsMessageSection()}
                <div className={secondaryWrapperClasses}>
                    <div className={gridViewClasses}>
                        <div className={gridItemClasses}>{this.filterBtn()}</div>
                        <div className={gridItemClasses}>
                            <SortBy />
                        </div>
                    </div>
                </div>
                <StoreFilterCategoryConnected
                    customWrapperClasses={StoreFilterCategoryClasses}
                    hideCurbsidePickupLabel
                />
                {this.searchResultCount()}
                <GallerySliderConnected />
                <FeatureFlag name="enableStickyFilter">
                    <FloatingFilterButtonConnected onClick={toggleSlider} />
                </FeatureFlag>
            </div>
        );
    };

    render() {
        const {
            props: {
                deviceType: { isDesktop },
            },
            renderMobile,
        } = this;

        return !isDesktop && renderMobile();
    }
}

const mapStateToProps = (store) => ({
    countOfSearchResults: store.countOfSearchResults,
    countOfSelectedFilters: store.countOfSelectedFilters,
    deviceType: store.context ? store.context.deviceType : {},
    disablePrevNoResultsMessage: selectDisablePrevNoResultsMessage(store),
    enableDesktopViewForTablet: selectEnableDesktopViewForTabletLandscapeOrientation(store),
    noResults: selectNoSearchResults(store),
    prevResults: selectLastAction(store),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(sliderActions, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FilterHeader));
